<script lang="ts">
  import type { AuthContext } from "$src/infrastructure/accounts/AuthContext";
  import { ContextTokens } from "$src/presentation/contexts/ContextTokens";
  import { getContext } from "svelte";
  import CustomerDetail from "./customer-detail.svelte";
  import { params } from "svelte-spa-router";
  import { useCustomer } from "../hooks/useCustomer";
  import NotFound from "$src/presentation/defaults/NotFound.svelte";
  import { isLoading } from "svelte-i18n";
  import LoadingIcon from "$src/presentation/defaults/loading-icon.svelte";
  import CustomerProjectsList from "$src/presentation/projects/index/customer-projects-list.svelte";
  import ProjectBreadcrumb from "$src/presentation/projects/components/app-breadcrumb.svelte";
  import MainTemplate from "$src/presentation/main/main-template.svelte";
  import AppBreadcrumb from "$src/presentation/projects/components/app-breadcrumb.svelte";
  import { StringUtils } from "$lib/stringUtils";

  let { activeGroupStore }: AuthContext = getContext(ContextTokens.Auth);

  $: groupStoreId = $activeGroupStore?.groupStoreId;
  $: customerId = StringUtils.getNumberOrDefault($params?.customerId, 0);

  $: customerQuery =
    groupStoreId && customerId ? useCustomer(groupStoreId, customerId) : null;
</script>

{#if $activeGroupStore?.groupStoreId}
<MainTemplate>
  <div slot="menu-top-left">
    <AppBreadcrumb groupStoreId={$activeGroupStore.groupStoreId} />
  </div>

  {#if $customerQuery?.isLoading}
    <LoadingIcon />
  {:else if groupStoreId && $customerQuery?.isSuccess}
    <div class="md:flex">
      <div class="md:max-w-md w-full md:sticky md:top-16 h-full">
        <CustomerDetail customer={$customerQuery.data} />
      </div>
      <div class="w-full">
        <div>
          <CustomerProjectsList
            {groupStoreId}
            customer={$customerQuery.data}
            onBack={null}
          />
        </div>
      </div>
    </div>
  {:else if $customerQuery?.isError}
    {$customerQuery.error.message}
  {/if}
</MainTemplate>
{/if}